import { render } from "./WelcomeMessage.vue?vue&type=template&id=c50686a8&scoped=true"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js"

import "./WelcomeMessage.vue?vue&type=style&index=0&id=c50686a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50686a8"]])

export default __exports__